var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 208264",
    d: "M11.1367 9.2793H30.1367C32.2585 9.2793 34.2933 10.1222 35.7936 11.6224C37.2939 13.1227 38.1367 15.1576 38.1367 17.2793V31.2793C38.1367 33.401 37.2939 35.4359 35.7936 36.9362C34.2933 38.4364 32.2585 39.2793 30.1367 39.2793H11.1367C9.01499 39.2793 6.98016 38.4364 5.47986 36.9362C3.97957 35.4359 3.13672 33.401 3.13672 31.2793V17.2793C3.13672 15.1576 3.97957 13.1227 5.47986 11.6224C6.98016 10.1222 9.01499 9.2793 11.1367 9.2793Z",
    fill: "#D7E251"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 98",
    d: "M5.76562 7.36856H21.6556V7.35156H5.76562V7.36856Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 99",
    d: "M5.76562 12.1216H21.6556V12.1016H5.76562V12.1216Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 100",
    d: "M5.76562 16.8967H21.6556V16.8887H5.76562V16.8967Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 101",
    d: "M13.7109 21.6893H21.6559V21.6533H13.7109V21.6893Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 102",
    d: "M29.724 32.779H4.973C3.9197 32.7777 2.90992 32.3587 2.16513 31.6139C1.42033 30.8691 1.00132 29.8593 1 28.806V1H26.424V5.766H32.78V29.774",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 104",
    d: "M26.4121 28.8065V6.56152",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 106",
    d: "M29.0361 32.7787C27.5881 32.7787 26.4121 30.9977 26.4121 28.8057",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 108",
    d: "M32.7802 29.7539C32.7644 30.5675 32.4275 31.3418 31.843 31.9079C31.2585 32.4741 30.4738 32.7861 29.6602 32.7759",
    stroke: "black",
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.6e8089975c0742c9e9914671fecf5c3a.svg";
export { ForwardRef as ReactComponent };